

















import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { AtomTextField } from '@/components/atoms'
import { dataStore, systemParameterStore } from '@/utils/store-accessor'
import { audioDing } from '@/utils'

@Component({
  components: {}
})
export default class InputCollectionNo extends ComponentVue {
  @Ref()
  textField!: AtomTextField

  @Prop({
    type: String,
    required: true
  })
  value!: string

  @Prop({
    type: Boolean,
    default: false
  })
  clearable!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  autofocus!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  error!: boolean

  @Prop({
    type: String,
    default: ''
  })
  errorMessage!: string

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  alphaNumeral!: boolean

  @Prop({
    type: String,
    default: ''
  })
  placeholder!: string

  @Prop({
    type: Boolean,
    default: false
  })
  determineAudio!: boolean

  get mask(): string {
    if (this.alphaNumeral) {
      return systemParameterStore.collectionNoMaskByAlphaNumHalf
    }

    return systemParameterStore.collectionNoMask
  }

  focus(): void {
    this.textField.atomTextField.focus()
  }

  onInput(value: string): void {
    this.$emit('input', value)

    // 入力文字列が資料番号最大桁数と同一の場合
    if (value.length === systemParameterStore.collectionNoMaxDigits) {
      this.$nextTick(this.onInputMaxDigits)
    }
  }

  onKeydownRight(): void {
    // カーソル位置が入力文字列の最後尾にある場合
    if (
      this.textField.atomTextField.$refs.input.selectionStart ===
      this.value.length
    ) {
      this.onKeydownRightEnd()
    }
  }

  // 資料番号を確定する時に発火するイベント
  // 複数のタイミングで発火する為、扱いに注意する事
  onDetermine(): void {
    if (this.value.length === 0) {
      return
    }

    if (dataStore.enabledBarcodeReaderSound && this.determineAudio) {
      audioDing()
    }

    this.$emit('determine')
  }

  @Emit('input:max-digits')
  onInputMaxDigits(): void {
    this.onDetermine()
  }

  @Emit('keydown:right:end')
  onKeydownRightEnd(): void {
    this.onDetermine()
  }

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
